import React from 'react'
import { RichText, type ComponentProps, type ExtendedRichTextData, type PartData } from '@enonic/react-components'
import ContentBlockPrototype from '/react4xp/components/prototype/ContentBlock'
import type { ContentBlockBackground, ContentBlockLink } from '/react4xp/components/prototype/ContentBlock/types'
import { EditorPlaceholder } from '/react4xp/components/shared/EditorPlaceholder'

type ContentBlockPartData = {
	overline?: string
	heading?: string
	body?: ExtendedRichTextData
	image?: { link?: string; alt?: string }
	video?: { src?: string }
	imagePosition?: 'left' | 'right'
	link?: ContentBlockLink
	background?: string
}

export const ContentBlock = ({ component, meta, data, common }: ComponentProps<PartData>) => {
	const { overline, heading, body, image, video, imagePosition = 'left', link, background = 'beige' } = (data || {}) as ContentBlockPartData

	// An unconfigured part still has to render something in Content Studio, or the
	// editor cannot select it to fill it in.
	if (!overline && !heading && !body && !image && !video && !link) {
		return (
			<EditorPlaceholder
				mode={meta?.mode}
				componentClass="content-block"
				title="Content block"
				reason="Nothing filled in yet - add an overline, heading, body, image, video or link."
			/>
		)
	}

	return (
		<ContentBlockPrototype
			overline={overline}
			heading={heading}
			body={body && <RichText tag="div" data={body} component={component} meta={meta} common={common} />}
			image={image?.link ? { src: image.link, alt: image.alt || '' } : undefined}
			video={video?.src ? { src: video.src } : undefined}
			mediaPosition={imagePosition}
			link={link}
			background={background as ContentBlockBackground}
		/>
	)
}
